import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header df-middle f-sm my-16" }
const _hoisted_2 = { class: "flex-1 ml-16 f-sm" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "mb-4" }, "WeTrade Analysis", -1)
const _hoisted_4 = { class: "df-middle df-between my-16 list-item" }
const _hoisted_5 = { class: "f-bold" }
const _hoisted_6 = { class: "t-right f-sm c-tip flex-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pic = _resolveComponent("Pic")
  const _component_Time = _resolveComponent("Time")
  const _component_Icon = _resolveComponent("Icon")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_component_router_link, {
    to: `/advice/${_ctx.advice.id}`
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Pic, {
          src: "logo",
          fallback: "/img/user/Avatar@2x.png",
          width: "32",
          height: "32",
          style: {"border-radius":"50%"}
        }),
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Time, {
            time: _ctx.advice.createTime,
            format: "MM-dd-yyyy HH:mm:ss",
            class: "c-tip"
          }, null, 8, ["time"])
        ]),
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.advice.code), 1),
        _createVNode(_component_Icon, {
          class: ["p-0 ml-4", {'c-success': _ctx.isUp, 'c-danger': !_ctx.isUp}],
          sm: "",
          name:  _ctx.isUp ? 'up': 'down'
        }, null, 8, ["class", "name"]),
        _createVNode("div", _hoisted_6, [
          _createVNode("p", {
            class: ["f-medium my-4 f-nm", { 'c-success': _ctx.isUp, 'c-danger': !_ctx.isUp }]
          }, _toDisplayString(_ctx.advice.informactionContent && _ctx.advice.informactionContent.split(',')[0]), 3)
        ])
      ])
    ]),
    _: 3
  }, 8, ["to"]))
}